import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import ConditionsDisclosures from '../ConditionsDisclosures';

import { addConditionDisclosureCount } from '../../../redux/slices/vdp/disclosureCount';

const ConditionsDisclosuresContainer = ({
  disclosures,
  tradeDetails,
  mediaList,
  tradeContext,
  tradeState
}) => {
  const disclosureResponse = disclosures;
  let isLoading = true;
  let hasErrors = false;
  // Error returned from the API
  if (disclosureResponse && disclosureResponse.message) {
    isLoading = false;
    hasErrors = true;
  }

  // TODO: Handle french translation string for this
  const notOnOverViewDisclosures = [
    'Any exterior photos showing damage',
    'Any interior photos showing damage',
    'Toute photo extérieure montrant des dommages',
    'Toute photo intérieure montrant des dommages'
  ];

  // To maintain an Ordered List
  const conditionDisclosuresList = [
    {
      type: '',
      disclosures: [],
      invalidDisclosures: [],
      media: [],
      category: 'Safety'
    },
    {
      type: '',
      disclosures: [],
      invalidDisclosures: [],
      media: [],
      category: 'Mechanical'
    },
    {
      type: '',
      disclosures: [],
      invalidDisclosures: [],
      media: [],
      category: 'Exterior'
    },
    {
      type: '',
      disclosures: [],
      invalidDisclosures: [],
      media: [],
      category: 'Interior'
    }
  ];
  let conditionDisclosureCount = 0;
  if (disclosureResponse && disclosureResponse.disclosures) {
    isLoading = false;
    disclosureResponse.disclosures.forEach(disclosure => {
      switch (disclosure.category) {
        case 'SAFETY':
          if (disclosure.valid) {
            conditionDisclosuresList[0].disclosures.push(disclosure.label);
            conditionDisclosureCount += 1;
          } else {
            conditionDisclosuresList[0].invalidDisclosures.push(
              disclosure.label
            );
          }
          if (conditionDisclosuresList[0].type === '') {
            conditionDisclosuresList[0].type =
              disclosureResponse.categories[disclosure.category].label;
          }
          break;
        case 'MECHANICAL':
          if (disclosure.valid) {
            conditionDisclosuresList[1].disclosures.push(disclosure.label);
            conditionDisclosureCount += 1;
          } else {
            conditionDisclosuresList[1].invalidDisclosures.push(
              disclosure.label
            );
          }
          if (conditionDisclosuresList[1].type === '') {
            conditionDisclosuresList[1].type =
              disclosureResponse.categories[disclosure.category].label;
          }
          break;
        case 'EXTERIOR':
          if (disclosure.valid) {
            conditionDisclosuresList[2].disclosures.push(disclosure.label);
            if (notOnOverViewDisclosures.indexOf(disclosure.label) <= -1) {
              conditionDisclosureCount += 1;
            }
          } else {
            conditionDisclosuresList[2].invalidDisclosures.push(
              disclosure.label
            );
          }
          if (conditionDisclosuresList[2].type === '') {
            conditionDisclosuresList[2].type =
              disclosureResponse.categories[disclosure.category].label;
          }
          break;
        case 'INTERIOR':
          if (disclosure.valid) {
            conditionDisclosuresList[3].disclosures.push(disclosure.label);
          } else {
            conditionDisclosuresList[3].invalidDisclosures.push(
              disclosure.label
            );
          }
          if (conditionDisclosuresList[3].type === '') {
            conditionDisclosuresList[3].type =
              disclosureResponse.categories[disclosure.category].label;
          }
          break;
        default:
          break;
      }
    });
  }

  if (disclosureResponse && disclosureResponse.media) {
    disclosureResponse.media.forEach(media => {
      switch (media.category) {
        case 'EXTERIOR':
          conditionDisclosuresList[2].media.push(media.label);
          conditionDisclosureCount += 1;
          break;
        case 'INTERIOR':
          conditionDisclosuresList[3].media.push(media.label);
          conditionDisclosureCount += 1;
          break;
        default:
          break;
      }
    });
  }

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      addConditionDisclosureCount({ condition: conditionDisclosureCount })
    );
  }, [disclosureResponse, conditionDisclosureCount, dispatch]);

  return (
    <ConditionsDisclosures
      conditionDisclosuresList={conditionDisclosuresList}
      tradeDetails={tradeDetails}
      conditionDisclosureCount={conditionDisclosureCount}
      mediaList={mediaList}
      isLoading={isLoading}
      hasErrors={hasErrors}
      tradeContext={tradeContext}
      tradeState={tradeState}
    />
  );
};

export default ConditionsDisclosuresContainer;
